module.exports = __webpack_public_path__ + "img/st5.b9d47b19.png";